import { getDisplayIdFromValue, getOrderStatusText, Order } from '@talos/kyoko';
import { appNotificationSeverityToToastVariant } from '../appNotificationSeverityToToastVariant';
import type { NotificationTransformerFn } from '../getNotificationRenderInfo';

export const OrderStatusNotificationTransformer: NotificationTransformerFn = notification => {
  const order = new Order(notification.Payload as Order);
  return {
    appInboxToastType: 'OrderStatus',
    variant: appNotificationSeverityToToastVariant(notification.Severity),
    title: `Order ${getOrderStatusText({ type: 'order', order, isCustomerOrder: false })}`,
    description: `Order ${getDisplayIdFromValue(order.OrderID)} for ${notification.Payload.Symbol}`,
    targetUrl: `/trading/order/${order.OrderID}/details`,
  };
};
